import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, UserRole, UserRoles } from '@fleet-beat/core';

@Pipe({
  name: 'userRolePipe',
})
export class UserRolePipe implements PipeTransform {
  transform(value: UserRole): string | null {
    if (!value) return null;
    return UserRoles.find((role: SelectOption) => role.value === value).label;
  }
}
